import { Link, NavLink, Navigate, Route, Routes } from "react-router-dom";
import { SignInButton } from "./components/SignInButton";
import { useActiveModel } from "./lib/activeModel";
import { useAuth } from "./lib/auth";
import { SlatePage } from "./pages/Slate";
import { ModelLabPage } from "./pages/ModelLab";
import { NotFoundPage } from "./pages/NotFound";
import { TermsPage } from "./pages/Terms";
import { PrivacyPage } from "./pages/Privacy";
import { ResponsibleGamingPage } from "./pages/ResponsibleGaming";

function AppHeader() {
  const { user } = useAuth();
  const { summary, error } = useActiveModel();

  return (
    <header className="app-header">
      <Link to="/" className="brand">
        <span className="brand-mark">PB</span>
        <span className="brand-name">Predabet</span>
      </Link>
      <nav className="app-nav">
        <NavLink to="/" end>
          Predictions
        </NavLink>
        <NavLink to="/lab">Model Lab</NavLink>
      </nav>
      {user && summary ? (
        <div className="app-active-model-pill" title={`Run ${summary.runId}`}>
          <span className="app-active-model-dot" aria-hidden />
          <span className="app-active-model-text">
            Active · <strong>{summary.configLabel}</strong> ·{" "}
            <code>{summary.runShort}…</code>
          </span>
        </div>
      ) : user && !summary && error ? (
        <span className="app-active-model-pill app-active-model-pill--warn" title={error}>
          Model status unavailable
        </span>
      ) : null}
      <div className="app-auth">
        <SignInButton />
      </div>
    </header>
  );
}

export function App() {
  return (
    <div className="app-shell">
      <AppHeader />

      <main className="app-main">
        <Routes>
          <Route path="/" element={<SlatePage />} />
          <Route path="/history" element={<Navigate to="/" replace />} />
          <Route path="/lab" element={<ModelLabPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/responsible-gaming" element={<ResponsibleGamingPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <footer className="app-footer">
        <span className="app-footer-left">
          Predabet &middot; WNBA probabilistic predictions &middot; For research and entertainment only. No betting advice.
        </span>
        <span className="app-footer-links">
          <Link to="/responsible-gaming">Responsible gaming</Link>
          <span aria-hidden>·</span>
          <Link to="/privacy">Privacy</Link>
          <span aria-hidden>·</span>
          <Link to="/terms">Terms</Link>
        </span>
      </footer>
    </div>
  );
}
